<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">THÊM MỚI ĐÁNH GIÁ</h3>
        <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT ĐÁNH GIÁ</h3>
        <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT ĐÁNH GIÁ</h3>
      </div>

      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-position="top"
        >
          <b-row>
            <b-col lg="6">
              <el-form-item label="Tiêu đề" prop="tieu_de">
                <el-input
                  v-model="mData.dataForm.tieu_de"
                  :disabled="mData.viewMode == 'detail'"
                  maxlength="60"
                  clearable
                  placeholder="Tối đa không quá 60 ký tự"
                ></el-input>
              </el-form-item>
              <el-form-item label="Tên dòng họ" prop="dong_ho.ten">
                <el-input
                  v-model="mData.dataForm.dong_ho.ten"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Địa chỉ dòng họ" prop="dong_ho.dia_chi">
                <el-input
                  v-model="mData.dataForm.dong_ho.dia_chi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Tên người đánh giá">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten_nguoi_danh_gia"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>

              <el-form-item label="Điều kiện" prop="dieu_kien">
                <el-select
                  v-model="mData.dataForm.hien_thi.dieu_kien"
                  multiple
                  filterable
                  placeholder="Chọn điều kiện"
                  :disabled="mData.viewMode === 'detail'"
                  clearable
                >
                  <el-option
                    v-for="item in dieuKien"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col lg="6">
              <el-form-item label="Giới thiệu">
                <el-input
                  type="textarea"
                  v-model="mData.dataForm.gioi_thieu"
                  class="slideText"
                  :disabled="mData.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
              <el-form-item label="Đường dẫn">
                <el-input
                  type="text"
                  v-model="mData.dataForm.duong_dan"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
              <b-row>
                <b-col lg="6">
                  <el-form-item label="Hiệu lực từ ngày">
                    <el-date-picker
                      v-model="mData.dataForm.hien_thi.hieu_luc_tu"
                      type="datetime"
                      format="dd/MM/yyyy HH:mm:ss"
                      :disabled="mData.viewMode == 'detail'"
                      @input="$forceUpdate()"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col lg="6">
                  <el-form-item label="Đến ngày">
                    <el-date-picker
                      v-model="mData.dataForm.hien_thi.hieu_luc_den"
                      type="datetime"
                      format="dd/MM/yyyy HH:mm:ss"
                      :disabled="mData.viewMode == 'detail'"
                      @input="$forceUpdate()"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" class="d-flex align-items-center">
                  <el-form-item style="margin-top: 34px">
                    <el-checkbox
                      v-model="this.mData.dataForm.hien_thi.an"
                      @change="fn_hideAssess"
                      :disabled="mData.viewMode == 'detail'"
                      >Ẩn đánh giá</el-checkbox
                    >
                  </el-form-item>
                </b-col>
                <b-col md="6">
                  <el-form-item
                    label="Thứ tự hiển thị"
                    v-if="
                      mData.viewMode == 'detail' || mData.viewMode == 'update'
                    "
                  >
                    <el-select
                      v-model="mData.dataForm.thu_tu"
                      :disabled="mData.viewMode == 'detail'"
                      @change="forceUpdateUI"
                      clearable
                    >
                      <el-option
                        v-for="item in mData.thu_tu_array"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <!-- thêm ảnh, video -->
          <b-row>
            <b-col cols="12" md="4">
              <div class="image-slide">
                <div class="d-flex">
                  <div
                    class="media-btn"
                    :class="{ deactiveBtn: mData.viewMode == 'detail' }"
                  >
                    <i class="fas fa-image"></i>
                    <label for="uploadImage">Thêm ảnh</label>
                    <input
                      type="file"
                      id="uploadImage"
                      accept="image/*"
                      @change="fn_uploadImage"
                      @click="fn_onInputClick"
                      style="display: none"
                      :disabled="mData.viewMode == 'detail'"
                    />
                  </div>
                  <el-button
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    v-show="mData.dataForm.anh_btn_show"
                    @click="fn_remove('anh')"
                    style="margin-left: 5px"
                  ></el-button>
                </div>
                <div style="min-height: 100px">
                  <FlowerSpinner
                    :animation-duration="2000"
                    :size="40"
                    :color="'#E0AB45'"
                    v-if="imageSpin"
                  />
                  <img
                    :src="mData.dataForm.anh_url"
                    alt="ảnh nền slide"
                    v-show="mData.dataForm.anh_show"
                    style="
                      margin-top: 10px;
                      max-height: 200px;
                      width: 100%;
                      object-fit: cover;
                    "
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="4">
              <div class="video-slide">
                <div class="d-flex">
                  <div
                    class="media-btn"
                    :class="{ deactiveBtn: mData.viewMode == 'detail' }"
                  >
                    <i class="fab fa-youtube"></i>
                    <label for="uploadVideo">Thêm video</label>
                    <input
                      type="file"
                      id="uploadVideo"
                      accept="video/*"
                      @change="fn_uploadVideo"
                      @click="fn_onInputClick"
                      style="display: none"
                      :disabled="mData.viewMode == 'detail'"
                    />
                  </div>
                  <el-button
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    v-show="mData.dataForm.video_btn_show"
                    @click="fn_remove('video')"
                    style="margin-left: 5px"
                  ></el-button>
                </div>

                <div style="min-height: 100px">
                  <FlowerSpinner
                    :animation-duration="2000"
                    :size="40"
                    :color="'#E0AB45'"
                    v-if="videoSpin"
                  />
                  <Media
                    :kind="'video'"
                    :controls="true"
                    :src="mData.dataForm.video_url"
                    v-show="mData.dataForm.video_show"
                    :style="{
                      'margin-top': '10px',
                      'max-height': '200px',
                      width: '100%',
                      'object-fit': 'cover',
                    }"
                  >
                  </Media>
                </div>
              </div>
            </b-col>

            <b-col cols="12" md="4"> </b-col>
          </b-row>

          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <el-button
              type="primary"
              @click="fn_addAssess()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import CategoryModel from "../../../views/admin/GeneralDirector/CategoryModel";
import DataForm from "../../../dataForm/dataFormDanhGia";
import Media from "@dongido/vue-viaudio";
import { Circle4 } from "vue-loading-spinner";
export default {
  components: {
    Media,
    Circle4,
  },
  data() {
    return {
      dieuKien: [
        { value: "all", label: "all" },
        { value: "android", label: "android" },
        { value: "ios", label: "ios" },
        { value: "iphone", label: "iphone" },
        { value: "ipad", label: "ipad" },
        { value: "pc", label: "pc" },
        { value: "windows", label: "windows" },
        { value: "macos", label: "macos" },
      ],
      aLang: LanguageService.lang,
      hideAssess: false,
      imageSpin: false,
      videoSpin: false,
      loading: true,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(CategoryModel.tableRules),
        validForm: {
          tieu_de: [ValidService.required],
        },
        total: "",
        thu_tu_array: [],
        thu_tu_current: "",
      },
    };
  },
  methods: {
    // lấy số lượng tối đa đánh giá để trường thu_tu tự động +1 khi tạo đánh giá mới thành công
    async fn_getTotal() {
      try {
        const response = await mushroom.ldp_danh_gia.listAsync();
        this.mData.total = response.meta.total;
        response.result.forEach((item) => {
          this.mData.thu_tu_array.push({
            value: item.thu_tu,
            label: item.thu_tu,
          });
        });
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async fn_initForm() {
      try {
        const response = await mushroom.ldp_danh_gia.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields:
            "id,tieu_de,gioi_thieu,dong_ho,ten_nguoi_danh_gia,anh_id,video_id,duong_dan,thu_tu,hien_thi",
        });
        this.mData.dataForm = response.result;
        this.mData.thu_tu_current = response.result.thu_tu;
        console.log("đánh giá chi tiết:", this.mData.dataForm);
        console.log("this.mData.thu_tu_current", this.mData.thu_tu_current);

        // đẩy thông tin ngày hiển thị vào datePicker
        // let array = [];
        // array.push(
        //   this.mData.dataForm.hien_thi.hieu_luc_tu,
        //   this.mData.dataForm.hien_thi.hieu_luc_den
        // );
        // this.mData.dataForm.hien_thi_ngay = array;

        // kiểm tra có id của ảnh, video rồi mới đẩy dữ liệu
        if (this.mData.dataForm.anh_id) {
          this.mData.dataForm.anh_url = mushroom.$file.linkBuilder.thumb
            .id(this.mData.dataForm.anh_id)
            .build();

          this.mData.dataForm.anh_show = true;
          this.mData.viewMode === "update"
            ? (this.mData.dataForm.anh_btn_show = true)
            : (this.mData.dataForm.anh_btn_show = false);
        }
        if (this.mData.dataForm.video_id) {
          this.mData.dataForm.video_url = mushroom.$file.linkBuilder.thumb
            .id(this.mData.dataForm.video_id)
            .build();
          this.mData.dataForm.video_show = true;
          this.mData.viewMode === "update"
            ? (this.mData.dataForm.video_btn_show = true)
            : (this.mData.dataForm.video_btn_show = false);
        }
        this.loading = false;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    // thêm đánh giá mới
    async fn_addAssess() {
      const ldp_danh_gia_object = {
        tieu_de: this.mData.dataForm.tieu_de,
        gioi_thieu: this.mData.dataForm.gioi_thieu,
        dong_ho: {
          ten: this.mData.dataForm.dong_ho.ten,
          dia_chi: this.mData.dataForm.dong_ho.dia_chi,
        },
        ten_nguoi_danh_gia: this.mData.dataForm.ten_nguoi_danh_gia,
        anh_id: this.mData.dataForm.anh_id,
        video_id: this.mData.dataForm.video_id,
        duong_dan: this.mData.dataForm.duong_dan,
        thu_tu: this.mData.total + 1,
        hien_thi: {
          an: this.hideAssess,
          hieu_luc_tu: this.mData.dataForm.hien_thi.hieu_luc_tu,
          hieu_luc_den: this.mData.dataForm.hien_thi.hieu_luc_den,
          dieu_kien: this.mData.dataForm.hien_thi.dieu_kien,
        },
      };
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          console.log(ldp_danh_gia_object);
          if (
            this.mData.dataForm.anh_id == undefined &&
            this.mData.dataForm.video_id == undefined
          ) {
            window.toastr.warning("Cần upload ảnh hoặc video");
            MethodService.stopLadda();
          } else {
            try {
              await mushroom.ldp_danh_gia.createAsync(ldp_danh_gia_object);
              MethodService.stopLadda();
              this.fn_resetForm();
              this.fn_resetDataForm();
              window.toastr.success("Thêm mới đánh giá thành công");
              this.$store.commit("fn_countDanhGia", "cong");
              this.$router.push({
                name: "DanhSachDanhGia",
              });
            } catch (error) {
              console.log(error);
              console.log(this.$refs.myForm.$el);
              if (error.code === 4) {
                window.toastr.error(this.aLang.no_server);
              } else if (error.code === 2) {
                window.toastr.error("Gặp sự cố tải dữ liệu");
              } else {
                window.toastr.error("Đã có lỗi xảy ra");
              }
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_hideAssess() {
      console.log("change");
      this.hideAssess = !this.hideAssess;
      this.mData.dataForm.hien_thi.an = this.hideAssess;
    },

    // thao tác ảnh
    async fn_uploadImage() {
      this.imageSpin = true;
      try {
        let res = await mushroom.$file.uploadAsync({
          file: document.getElementById("uploadImage").files[0], // required
        });
        this.imageSpin = false;
        console.log("image: ", res.result);
        this.$forceUpdate();
        this.mData.dataForm.anh_id = res.result;
        this.mData.dataForm.anh_show = true;
        this.mData.dataForm.anh_url = mushroom.$file.linkBuilder.thumb
          .id(res.result)
          .build();
        this.mData.dataForm.anh_btn_show = true;
      } catch (error) {
        console.log(error);
        if (error.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (error.code === 2) {
          window.toastr.error("Gặp sự cố tải dữ liệu");
        } else {
          window.toastr.error("Đã có lỗi xảy ra");
        }
      }
    },

    // thao tác video
    async fn_uploadVideo() {
      this.videoSpin = true;
      try {
        let res = await mushroom.$file.uploadAsync({
          file: document.getElementById("uploadVideo").files[0], // required
        });
        this.videoSpin = false;
        console.log("video: ", res.result);
        this.$forceUpdate();
        this.mData.dataForm.video_id = res.result;
        this.mData.dataForm.video_show = true;
        this.mData.dataForm.video_url = mushroom.$file.linkBuilder.thumb
          .id(res.result)
          .build();
        this.mData.dataForm.video_btn_show = true;
      } catch (e) {
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        }
      }
    },

    // xóa ảnh và video vừa upload
    fn_remove(item) {
      if (item == "video") {
        this.mData.dataForm.video_show = false;
        this.mData.dataForm.video_url = "";
        this.mData.dataForm.video_id = null;
        this.mData.dataForm.video_btn_show = false;
      }
      if (item == "anh") {
        this.mData.dataForm.anh_show = false;
        this.mData.dataForm.anh_url = "";
        this.mData.dataForm.anh_id = null;
        this.mData.dataForm.anh_btn_show = false;
      }
      this.$forceUpdate();
    },

    // reset lại thẻ input khi vừa xóa ảnh/video
    fn_onInputClick(event) {
      event.target.value = "";
    },

    // cập nhật đánh giá
    async fn_update() {
      const ldp_danh_gia_object = {
        id: this.$router.currentRoute.params.id,
        tieu_de: this.mData.dataForm.tieu_de,
        gioi_thieu: this.mData.dataForm.gioi_thieu,
        ten_nguoi_danh_gia: this.mData.dataForm.ten_nguoi_danh_gia,
        dong_ho: {
          ten: this.mData.dataForm.dong_ho.ten,
          dia_chi: this.mData.dataForm.dong_ho.dia_chi,
        },
        anh_id: this.mData.dataForm.anh_id,
        anh_nho_id: this.mData.dataForm.anh_nho_id,
        video_id: this.mData.dataForm.video_id,
        duong_dan: this.mData.dataForm.duong_dan,
        thu_tu: this.mData.dataForm.thu_tu,
        hien_thi: {
          an: this.mData.dataForm.hien_thi.an,
          hieu_luc_tu: this.mData.dataForm.hien_thi.hieu_luc_tu,
          hieu_luc_den: this.mData.dataForm.hien_thi.hieu_luc_den,
          dieu_kien: this.mData.dataForm.hien_thi.dieu_kien,
        },
      };
      console.log("đánh giá cập nhật:", ldp_danh_gia_object);
      if (!this.mData.dataForm.anh_id && !this.mData.dataForm.video_id) {
        window.toastr.warning("Cần upload ảnh hoặc video");
        MethodService.stopLadda();
      } else {
        try {
          // cập nhật thứ tự của đánh giá bị lấy mất thứ tự
          const responseOld = await mushroom.ldp_danh_gia.listAsync({
            filters: ["thu_tu=" + this.mData.dataForm.thu_tu],
          });
          const ldp_danh_gia_old = {
            id: responseOld.result[0].id,
            thu_tu: this.mData.thu_tu_current,
          };
          await mushroom.ldp_danh_gia.partialUpdateAsync(ldp_danh_gia_old);

          // cập nhật thứ tự mới cho đánh giá đang thao tác cập nhật
          const response = await mushroom.ldp_danh_gia.partialUpdateAsync(
            ldp_danh_gia_object
          );
          if (response.result == this.$router.currentRoute.params.id) {
            window.toastr.success("Cập nhật Slide thành công");
            MethodService.stopLadda();
            this.$router.push({
              name: "DanhSachDanhGia",
            });
          } else {
            window.toastr.warning("Dữ liệu không thay đổi");
            MethodService.stopLadda();
          }
        } catch (error) {
          MethodService.stopLadda();
          console.error("Có lỗi: %o", error);
          if (e.code === 4) {
            window.toastr.error(this.aLang.no_server);
          } else if (e.code === 2) {
            window.toastr.error("Máy chủ không phản hồi");
          }
        }
      }
    },

    // quay lại danh sách đánh giá
    fn_back() {
      this.$router.go(-1);
    },

    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },
    fn_resetDataForm() {
      this.mData.dataForm.thu_tu = undefined;
      this.mData.dataForm.anh_id = null;
      this.mData.dataForm.anh_show = false;
      this.mData.dataForm.anh_btn_show = false;
      this.mData.dataForm.anh_url = undefined;
      this.mData.dataForm.video_show = false;
      this.mData.dataForm.video_id = null;
      this.mData.dataForm.video_url = undefined;
      this.mData.dataForm.video_btn_show = false;
    },
    fn_cancel() {
      this.fn_resetForm();
      this.fn_resetDataForm();
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
  },

  async created() {
    await this.fn_getTotal();

    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute.name);
    if (this.$router.currentRoute.name == "ThemDanhGia") {
      this.mData.viewMode = "create";
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "ChiTietDanhGia") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatDanhGia") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .slideText textarea {
  height: 111px;
}
label {
  margin-bottom: 0;
}
.uploadImage {
  position: relative;
}

::v-deep .el-upload--text {
  display: none;
}
::v-deep .flower-spinner {
  background-color: transparent;
}
.video {
  border: 1px solid #dcdfe6;
  padding: 10px;
  border-radius: 3px;
  &__btnGroup {
    margin-bottom: 5px;
  }
}
.media-btn {
  padding: 5px 15px;
  border: 1px solid #b3d8ff;
  border-radius: 3px;
  width: fit-content;

  color: #3b5dbf;
  background-color: #ecf5ff;
  transition: 0.3s;
  &:hover {
    background-color: #409eff;
    color: #fff;
  }
  label {
    cursor: pointer;
  }
  i {
    margin-right: 5px;
  }
}
.deactiveBtn {
  border: 1px solid #d3d4d6;
  background-color: #f4f4f5;
  color: rgb(109, 109, 109);
  &:hover {
    background-color: #f4f4f5;
    color: rgb(109, 109, 109);
  }
  label,
  i {
    cursor: no-drop;
  }
}
</style>
